export interface QueryParams {
	start?: string // start date
	end?: string // end date
	col?: string // visible columns in the table
	cov?: string // coverage types
	sic?: string // SIC industry types
	ind?: string // industry types
  wg?: string // wholesaler groups
	cg?: string // carrier groups
	at?: string // attachment points
	r?: string // retention
	ca?: string // client attributes
  ag?: string // agency types
	dept?: string // departments
	ext?: string // show external policies
	exp?: string // show expired policies
	due?: string // show policies within expiration window
	own?: string // ownership types (comma-separated: Public,Private,Not Specified)
	run_y?: string // runoff
	run_n?: string // no runoff
	pri?: string // primary
	exs?: string // excess
	cur?: string // current only
}

export const enum POLICY_TABLE_COLUMNS {
  YEAR = 'year',
  ACCOUNT_NAME = 'accountName',
  ACCOUNT_ATTRIBUTES = 'accountAttributes',
  PARENT_ACCOUNT_NAME = 'parentAccountName',
  POLICY_TYPE = 'policyType',
  COVERAGE_TYPE = 'coverageType',
  PRODUCT = 'product',
  DESCRIPTION = 'description',
  TOP_LEVEL_INDUSTRY = 'topLevelIndustry',
  GENERIC_INDUSTRY = 'industry',
  OWNERSHIP_TYPE = 'ownershipType',
  CARRIER_GROUP = 'carrierGroup',
  ISSUING_COMPANY_NAME = 'issuingCompanyName',
  CARRIER_RATING = 'carrierRating',
  SYNDICATE = 'syndicate',
  SYNDICATE_AGENT = 'syndicateAgent',
  WHOLESALER = 'wholesaler',
  UNDERWRITER_NAME = 'underwriterName',
  LIMIT = 'limit',
  OCCURRENCE_LIMIT = 'occurrenceLimit',
  ATTACHMENT_POINT = 'attachmentPoint',
  RETENTION = 'retention',
  PREMIUM = 'premium',
  PREMIUM_ANNUALIZED = 'premiumAnnualized',
  PPM = 'ppm',
  ANNUALIZED_PPM = 'annualizedPPM',
  ILF = 'ilf',
  AUDIT_AMT = 'auditAmt',
  QUOTA_SHARE_TOTAL = 'quotaShareTotal',
  POLICY_ID = 'policyID',
  EFFECTIVE_DATE = 'effectiveDate',
  EXPIRATION_DATE = 'expirationDate',
  SIDE_A_TYPE = 'sideAType',
  RUNOFF = 'runoff',
  LINE_STATUS_CODE = 'lineStatusCode',
  BILL_MODE = 'billMode',
  AGENCY_NAME = 'agencyName',
  COMMISSION_BILLED = 'commissionBilled',
  FEES_BILLED = 'feesBilled',
  ENTERED_DATE = 'enteredDate',
  PREMIUM_PAYABLE_NAME = 'premiumPayableName',
  REBATE_AMT = 'rebateAmt',
  BROKER = 'broker',
  PROFIT_CENTER = 'profitCenter',
  CURR_TERM_AMOUNT = 'currTermAmount',
  OBLIGEE_NAME = 'obligeeName',
  OBLIGEE_ADDRESS = 'obligeeAddress',
  PRINCIPAL_NAME = 'principalName',
  PRINCIPAL_ADDRESS = 'principalAddress',
  UNDERWRITING_NAME = 'underwritingName',
  UNDERWRITING_ADDRESS = 'underwritingAddress',
  CANCELABLE = 'cancelable',
  NET_AMOUNT = 'netAmount',
}

export const USStates = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
  { label: 'D.C.', value: 'DC' },
]

export const USStatesMap = new Map<string, string>(
  USStates.map(state => [state.value, state.label])
)
